import { Trans } from 'react-i18next';
import { ModalDialog } from './ModalDialog';
export function ArchiveConfirmDialog({
  resourceName,
  resourceType,
  onCancel,
  onConfirm,
  show
}) {
  return <ModalDialog show={show} type="archive" onCancel={onCancel} headerContent={<Trans ns="common" i18nKey="modal.confirmArchiveWithType" values={{
    resourceType
  }} />} bodyContent={<Trans ns="common" i18nKey="modal.confirmArchiveBody" values={{
    resourceName
  }} />} onConfirm={onConfirm} />;
}